var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLuxury(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/TIF-luxery-wellness-S") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hotelcard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Theme/Luxury",
    transform: "translate(-8.000000, -10.000000)",
    fill: "#00A1DE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/TIF-luxery-wellness-S",
    transform: "translate(8.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,4 L8,12 L0,4 L2.4,-1.77635684e-15 L13.6,-1.77635684e-15 C14.4,1.3336 15.2,2.6664 16,4 Z M9.1,9.2032 L13.7032,4.6 L10.8304,4.6 C10.2984,6.1504 9.692,7.6744 9.1,9.2032 Z M5.1832,4.6 L2.2968,4.6 L6.856,9.1592 C6.2736,7.6488 5.7448,6.1176 5.1832,4.6 Z M9.5344,4.6 L6.4656,4.6 L8,8.6912 L9.5344,4.6 Z M3.0792,1.2 L1.7592,3.4 L5.1312,3.4 L5.6816,1.2 L3.0792,1.2 Z M6.9184,1.2 L6.3688,3.4 L9.6312,3.4 L9.0816,1.2 L6.9184,1.2 Z M10.3184,1.2 L10.8688,3.4 L14.2408,3.4 L12.9208,1.2 L10.3184,1.2 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuxury);
export default __webpack_public_path__ + "static/media/Luxury.bc7a110e575ec81909e7f483ba0a1db4.svg";
export { ForwardRef as ReactComponent };